// extracted by mini-css-extract-plugin
export default {"section":"FeatureGrid_section__bhMGS","grid":"FeatureGrid_grid__c04Tt","icon":"FeatureGrid_icon__0Wv6D","title":"FeatureGrid_title__Tj-Ud","text":"FeatureGrid_text__C3rqm"};